'use client'

import cx from 'classnames'
import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'

import RequiredLabel from '@/components/Form/Atoms/RequiredLabel'
import { Props } from '@/components/Form/Organisms/SurveyForm/SurveyFormOption/SurveyFormCheckbox'

export default function SurveyFormSimpleCheckbox({ surveyAnswersKeyName, surveyQuestion, index }: Props) {
  const { watch, register } = useFormContext()

  const watchValue = watch(surveyAnswersKeyName)

  return (
    <div className={cx('c-surveyForm-surveyForm__questions')}>
      <label className="c-inputBase__label u-mb14">
        <span>
          {index !== null && <span>{index + 1}. </span>}
          {surveyQuestion.name}
          {surveyQuestion.answerRequired && <RequiredLabel />}
        </span>
      </label>

      <div className={cx('c-surveyForm-surveyForm__questions-simple-checkbox')}>
        {surveyQuestion.surveyOptions.map((surveyOption) => {
          return (
            <Fragment key={surveyOption.surveyOptionId}>
              <label
                htmlFor={surveyOption.surveyOptionId}
                className={cx('c-surveyForm-surveyForm__questions-simple-checkbox-label', {
                  // @ts-ignore
                  'c-surveyForm-surveyForm__questions-simple-checkbox-label--checked': (
                    watchValue[surveyQuestion.surveyQuestionId] || []
                  ).includes(surveyOption.surveyOptionId),
                })}
              >
                <p>{surveyOption.name}</p>

                <input
                  id={surveyOption.surveyOptionId}
                  type="checkbox"
                  value={surveyOption.surveyOptionId}
                  {...register(`${surveyAnswersKeyName}.${surveyQuestion.surveyQuestionId}`)}
                />
              </label>
            </Fragment>
          )
        })}
      </div>
      <p className={cx('u-help', 'u-mb10', 'c-surveyForm-surveyForm__help')}>※ 複数回答可能</p>
    </div>
  )
}
